import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import { Input, InputLabel } from '@mui/material';
import { MenuItem } from '@mui/material';
import { FormControl, FormHelperText, FormControlLabel, FormGroup, FormLabel } from '@mui/material';
import {Select} from '@mui/material';
import {Grid} from '@mui/material';
import {Switch} from '@mui/material';
import * as Numbro from 'numbro';

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	formControl: {
        width: 320,
        marginTop: 30
    },
    frequency: {
        marginBottom: 30,
		width: 320
    }
});

enum Frequency {
	Hourly,
	Daily,
	Weekly,
	Monthly
}

const frequencyOpts: any[] = [
	//{label: "Hourly", value: Frequency.Hourly},
	{ label: 'Daily', value: Frequency.Daily },
	{ label: 'Weekly', value: Frequency.Weekly },
	{ label: 'Monthly', value: Frequency.Monthly }
];

const timeOpts: any[] = [
	{ label: '12:00 am', value: '0 0' },
	{ label: '12:30 am', value: '30 0' },
	{ label: '1:00 am', value: '0 1' },
	{ label: '1:30 am', value: '30 1' },
	{ label: '2:00 am', value: '0 2' },
	{ label: '2:30 am', value: '30 2' },
	{ label: '3:00 am', value: '0 3' },
	{ label: '3:30 am', value: '30 3' },
	{ label: '4:00 am', value: '0 4' },
	{ label: '4:30 am', value: '30 4' },
	{ label: '5:00 am', value: '0 5' },
	{ label: '5:30 am', value: '30 5' },
	{ label: '6:00 am', value: '0 6' },
	{ label: '6:30 am', value: '30 6' },
	{ label: '7:00 am', value: '0 7' },
	{ label: '7:30 am', value: '30 7' },
	{ label: '8:00 am', value: '0 8' },
	{ label: '8:30 am', value: '30 8' },
	{ label: '9:00 am', value: '0 9' },
	{ label: '9:30 am', value: '30 9' },
	{ label: '10:00 am', value: '0 10' },
	{ label: '10:30 am', value: '30 10' },
	{ label: '11:00 am', value: '0 11' },
	{ label: '11:30 am', value: '30 11' },
	{ label: '12:00 pm', value: '0 12' },
	{ label: '12:30 pm', value: '0 12' },
	{ label: '1:00 pm', value: '0 13' },
	{ label: '1:30 pm', value: '30 13' },
	{ label: '2:00 pm', value: '0 14' },
	{ label: '2:30 pm', value: '30 14' },
	{ label: '3:00 pm', value: '0 15' },
	{ label: '3:30 pm', value: '30 15' },
	{ label: '4:00 pm', value: '0 16' },
	{ label: '4:30 pm', value: '30 16' },
	{ label: '5:00 pm', value: '0 17' },
	{ label: '5:30 pm', value: '30 17' },
	{ label: '6:00 pm', value: '0 18' },
	{ label: '6:30 pm', value: '30 18' },
	{ label: '7:00 pm', value: '0 19' },
	{ label: '7:30 pm', value: '30 19' },
	{ label: '8:00 pm', value: '0 20' },
	{ label: '8:30 pm', value: '30 20' },
	{ label: '9:00 pm', value: '0 21' },
	{ label: '9:30 pm', value: '30 21' },
	{ label: '10:00 pm', value: '0 22' },
	{ label: '10:30 pm', value: '30 22' },
	{ label: '11:00 pm', value: '0 23' },
	{ label: '11:30 pm', value: '30 23' }
];

const minuteOpts: any[] = [
	{ label: 'On the hour', value: '0' },
	{ label: '15 minutes past the hour', value: '15' },
	{ label: '30 minutes past the hour', value: '30' },
	{ label: '45 minutes past the hour', value: '45' }
];

const dayOfWeekOpts: any[] = [
	{ label: 'Sunday', value: 0 },
	{ label: 'Monday', value: 1 },
	{ label: 'Tuesday', value: 2 },
	{ label: 'Wednesday', value: 3 },
	{ label: 'Thursday', value: 4 },
	{ label: 'Friday', value: 5 },
	{ label: 'Saturday', value: 6 }
];

const dayOfMonthOpts: any[] = [
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
	{ label: '5', value: 5 },
	{ label: '6', value: 6 },
	{ label: '7', value: 7 },
	{ label: '8', value: 8 },
	{ label: '9', value: 9 },
	{ label: '10', value: 10 },
	{ label: '11', value: 11 },
	{ label: '12', value: 12 },
	{ label: '13', value: 13 },
	{ label: '14', value: 14 },
	{ label: '15', value: 15 },
	{ label: '16', value: 16 },
	{ label: '17', value: 17 },
	{ label: '18', value: 18 },
	{ label: '19', value: 19 },
	{ label: '20', value: 20 },
	{ label: '21', value: 21 },
	{ label: '22', value: 22 },
	{ label: '23', value: 23 },
	{ label: '24', value: 24 },
	{ label: '25', value: 25 },
	{ label: '26', value: 26 },
	{ label: '27', value: 27 },
	{ label: '28', value: 28 },
	{ label: '29', value: 29 },
	{ label: '30', value: 30 },
	{ label: '31', value: 31 }
];

interface Props extends React.HTMLProps<HTMLDivElement> {
	onCronChange: (cron: string, valid: boolean) => void;
	frequencyPrompt?: string;
	defaultSecond?: string;
	defaultMinute?: string;
	defaultHour?: string;
	defaultDayOfWeek?: string;
	defaultDayOfMonth?: string;
	cron?: string;
	readOnly?: boolean;
}

type State = {
	frequencyPrompt?: string;
	optionFrequency?: any;
	optionTime?: {
		minute: string;
		hour: string;
	};
	optionMinutes?: string;
	optionDaysOfWeek?: string;
	optionDaysOfMonth?: string;
	cron: {
		second: string;
		minute: string;
		hour: string;
		dayOfMonth: string;
		month: string;
		dayOfWeek: string;
	};
};

class CronSelectView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			cron: {
				second: '0',
				minute: '',
				hour: '',
				dayOfMonth: '',
				month: '',
				dayOfWeek: ''
			}
		};
		this.state = this.handleProps(this.state, props);
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	handleProps = (state: State, props: Props & WithStyles<keyof typeof styles>): State => {
		if (props.cron) {
			var parts = props.cron.split(' ');
			if (parts.length != 6) {
				console.error(`"${props.cron}" is not a valid cron`);
				return state;
			}
			state.cron = {
				second: parts[0],
				minute: parts[1],
				hour: parts[2],
				dayOfMonth: parts[3],
				month: parts[4],
				dayOfWeek: parts[5]
			};
		}
		if (props.frequencyPrompt) {
			state.frequencyPrompt = props.frequencyPrompt;
		} else {
			state.frequencyPrompt = 'Select frequency...';
		}
		return state;
	};

	updateFrequency = (e: any) => {
		const newValue = e.target;
		const self = this;
		let cron = this.state.cron;
		switch (newValue.value) {
			case Frequency.Hourly:
				cron.minute = self.props.defaultMinute || '0';
				cron.hour = '*';
				cron.dayOfWeek = '*';
				cron.dayOfMonth = '*';
				cron.month = '*';

				break;
			case Frequency.Daily:
				cron.minute = self.props.defaultMinute || '0';
				cron.hour = self.props.defaultHour || '8';
				cron.dayOfWeek = '*';
				cron.dayOfMonth = '*';
				cron.month = '*';
				break;
			case Frequency.Weekly:
				cron.minute = self.props.defaultMinute || '0';
				cron.hour = self.props.defaultHour || '8';
				cron.dayOfWeek = self.props.defaultDayOfWeek || '0';
				cron.dayOfMonth = '*';
				cron.month = '*';
				break;
			case Frequency.Monthly:
				cron.minute = self.props.defaultMinute || '0';
				cron.hour = self.props.defaultHour || '8';
				cron.dayOfMonth = self.props.defaultDayOfMonth || '1';
				cron.dayOfWeek = '*';
				cron.month = '*';
				break;
		}
		this.setState(
			{
				optionFrequency: newValue,
				cron: cron
			},
			self.updateCron
		);
	};

	determineFrequency = (): Frequency | undefined => {
		if (
			this.state.cron.hour === '*' &&
			this.state.cron.dayOfWeek === '*' &&
			this.state.cron.dayOfMonth === '*' &&
			this.state.cron.month === '*'
		) {
			return Frequency.Hourly;
		} else if (
			(this.state.cron.dayOfWeek === '*' || this.state.cron.dayOfWeek === '1,2,3,4,5') &&
			this.state.cron.dayOfMonth === '*' &&
			this.state.cron.month === '*'
		) {
			return Frequency.Daily;
		} else if (this.state.cron.dayOfMonth === '*' && this.state.cron.month === '*') {
			return Frequency.Weekly;
		} else if (this.state.cron.dayOfWeek === '*' && this.state.cron.month === '*') {
			return Frequency.Monthly;
		}

		return undefined;
	};

	updateTime = (e: any) => {
		const self = this;
		let cron = this.state.cron;
		const parts = e.target.value.split(' ');
		cron.minute = parts[0];
		cron.hour = parts[1];
		this.setState(
			{
				cron: cron
			},
			self.updateCron()
		);
	};

	updateMinute = (newValue: any) => {
		const self = this;
		let cron = this.state.cron;
		cron.minute = newValue.value;
		this.setState(
			{
				cron: cron
			},
			self.updateCron()
		);
	};

	updateDayOfWeek = (val: any) => (evt: React.FormEvent<HTMLInputElement>) => {
		const self = this;
		let days: string[] = [];
		if (this.state.cron.dayOfWeek.trim()) {
			days = this.state.cron.dayOfWeek.trim().split(',');
		}
		if (evt.currentTarget && evt.currentTarget.checked) {
			days = days.concat(val.toString());
		} else {
			days = days.filter((v) => v !== val.toString());
		}

		let cron = this.state.cron;
		
		cron.dayOfWeek = days.sort().join(',');

		this.setState(
			{
				cron: cron
			},
			self.updateCron()
		);
	};

	updateDayOfMonth = (val: any) => (evt: React.FormEvent<HTMLInputElement>) => {
		const self = this;
		let days: string[] = [];
		if (this.state.cron.dayOfMonth.trim()) {
			days = this.state.cron.dayOfMonth.trim().split(',');
		}

		if (evt.currentTarget && evt.currentTarget.checked) {
			days = days.concat(val);
		} else { 
			days = days.filter((v) => v != val);
		}

		let cron = this.state.cron;

		cron.dayOfMonth = days.sort((a: string, b: string)=>{return parseInt(a)-parseInt(b)}).join(',');

		this.setState({ cron: cron }, self.updateCron());
	};

	toggleWeekdaysOnly = (evt: React.FormEvent<HTMLInputElement>) => {
		const self = this;
		let cron = this.state.cron;

		if (evt.currentTarget && evt.currentTarget.checked) {
			cron.dayOfWeek = '1,2,3,4,5';
		} else {
			cron.dayOfWeek = '*';
		}

		this.setState({ cron: cron }, self.updateCron());
	};

	updateCron = (): any => {
		const cron: string = `${this.state.cron.second} ${this.state.cron.minute} ${this.state.cron.hour} ${this.state
			.cron.dayOfMonth} ${this.state.cron.month} ${this.state.cron.dayOfWeek}`;
		const parts = cron.split(' ');
		let valid: boolean = false;
		if (
			parts.length === 6 &&
			this.state.cron.second &&
			this.state.cron.minute &&
			this.state.cron.hour &&
			this.state.cron.dayOfMonth &&
			this.state.cron.month &&
			this.state.cron.dayOfWeek
		) {
			valid = true;
		}
			this.props.onCronChange(cron, valid);
	};

	includes = (arr: string[], val: string): boolean | undefined => {
		for (var v of arr) {
			if (val === v) {
				return true;
			}
		}

		return false;
	};

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		var frequency: Frequency | undefined = this.determineFrequency();
        var frequencyDetails: object | null = null;

		if (frequency != undefined) {
			switch (frequency as Frequency) {
				case Frequency.Hourly:
					if (this.props.readOnly) {
						if (this.state.cron.minute === '0') {
							frequencyDetails = <span>Hourly at the top of the hour </span>;
						} else {
							frequencyDetails = <span>Hourly at {this.state.cron.minute} minutes past the hour</span>;
						}
					} else {
						frequencyDetails = (
							<FormControl className={classes.formControl}>
								<InputLabel htmlFor="minute-opts">When during the hour?</InputLabel>
								<Select
									value={this.state.cron.minute || ''}
									onChange={this.updateMinute}
									input={<Input name="minute-opts" id="minute-opts" />}
									autoWidth
								>
									{minuteOpts.map((o) => {
										return (
											<MenuItem key={o.label} value={o.value}>
												{o.label}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						);
					}
					break;
				case Frequency.Daily:
					let dailyTimeValue = '';
					if (this.state.cron.minute && this.state.cron.hour) {
						dailyTimeValue = this.state.cron.minute + ' ' + this.state.cron.hour;
					}

					if (this.props.readOnly) {
						let hour = parseInt(this.state.cron.hour);
						let minute = this.state.cron.minute;
						let weekdays ;
						if (minute.length == 1) {
							minute = '0' + minute;
						}
						if (this.state.cron.dayOfWeek === '1,2,3,4,5') {
							weekdays = '(Weekdays Only)';
						}
						if (hour < 13) {
							frequencyDetails = (
								<span>
									Daily at {this.state.cron.hour}:{minute}am {weekdays}{' '}
								</span>
							);
						} else {
							frequencyDetails = (
								<span>
									Daily at {(hour - 12).toString()}:{minute}pm {weekdays}{' '}
								</span>
							);
						}
					} else {
						frequencyDetails = (
							<div>
								<FormControl className={classes.formControl}>
									<InputLabel htmlFor="time-opts">At what time during the day?</InputLabel>
									<Select
										value={dailyTimeValue || ''}
										onChange={this.updateTime}
										input={<Input name="time-opts" id="time-opts" />}
										autoWidth
									>
										{timeOpts.map((o) => {
											return (
												<MenuItem key={o.label} value={o.value}>
													{o.label}
												</MenuItem>
											);
										})}
									</Select>
									<FormHelperText>The time the email will be delivered.</FormHelperText>
								</FormControl>

								<div className="form-check form-check-inline day-of-week">
								<FormControl className={classes.formControl}>
									<FormControlLabel
                                      label="Weekdays Only"
                                      control={
									<Switch
										checked={this.state.cron.dayOfWeek === '1,2,3,4,5'}
										onChange={this.toggleWeekdaysOnly}
										aria-label="checkedA"
										color="secondary"
									/>
                                      }
                                    />
								</FormControl>
								</div>
							</div>
						);
					}
					break;

				case Frequency.Weekly:
					//let daysOfWeek = ""
					let weeklyTimeValue = '';
					if (this.state.cron.minute && this.state.cron.hour) {
						weeklyTimeValue = this.state.cron.minute + ' ' + this.state.cron.hour;
					}
					let days = this.state.cron.dayOfWeek.split(',');
					if (this.props.readOnly) {
						let hour = parseInt(this.state.cron.hour);
						let minute = this.state.cron.minute;
						let daysOfWeek = this.state.cron.dayOfWeek.split(',');
						let days = '';
						if (minute.length == 1) {
							minute = '0' + minute;
						}
						for (var i = 0; i < daysOfWeek.length; i++) {
							let day = '';
							switch (daysOfWeek[i]) {
								case '0':
									day = 'Sunday';
									break;
								case '1':
									day = 'Monday';
									break;
								case '2':
									day = 'Tuesday';
									break;
								case '3':
									day = 'Wednesday';
									break;
								case '4':
									day = 'Thursday';
									break;
								case '5':
									day = 'Friday';
									break;
								case '6':
									day = 'Saturday';
									break;
							}
							if (i == 0) {
								days = day;
							} else {
								if (i === daysOfWeek.length - 1) {
									days += ' and ' + day;
								} else {
									days += ', ' + day;
								}
							}
						}

						if (hour < 13) {
							frequencyDetails = (
								<span>
									Weekly on {days} at {this.state.cron.hour}:{minute}am{' '}
								</span>
							);
						} else {
							frequencyDetails = (
								<span>
									Weekly on {days} at {(hour - 12).toString()}:{minute}pm{' '}
								</span>
							);
						}
					} else {
						frequencyDetails = (
							<div>
								<FormGroup>
								    <FormLabel>Which days of the week?</FormLabel>
									<Grid container>
										{dayOfWeekOpts.map((o) => {
											return (
												<Grid item key={o.label} xs={6} sm={4} md={3} lg={2}>
													<FormControlLabel
														control={
															<Switch
																color="secondary"
																checked={this.includes(days, o.value.toString())}
																onChange={this.updateDayOfWeek(o.value)}
															/>
														}
														label={o.label}
													/>
												</Grid>
											);
										})}
									</Grid>
								</FormGroup>
								<FormControl className={classes.formControl}>
									<InputLabel htmlFor="time-opts">At what time during the day?</InputLabel>
									<Select
										value={weeklyTimeValue || ''}
										onChange={this.updateTime}
										input={<Input name="time-opts" id="time-opts" />}
										autoWidth
									>
										{timeOpts.map((o) => {
											return (
												<MenuItem key={o.label} value={o.value}>
													{o.label}
												</MenuItem>
											);
										})}
									</Select>
									<FormHelperText>The time the email will be delivered.</FormHelperText>
								</FormControl>
							</div>
						);
					}
					break;
				case Frequency.Monthly:
					let monthlyTimeValue = '';
					if (this.state.cron.minute && this.state.cron.hour) {
						monthlyTimeValue = this.state.cron.minute + ' ' + this.state.cron.hour;
					}
					let dayOfMonth = this.state.cron.dayOfMonth.split(',');
					if (this.props.readOnly) {
						let hour = parseInt(this.state.cron.hour);
						let minute = this.state.cron.minute;
						let daysOfMonth = this.state.cron.dayOfMonth.split(',');
						let days = '';
						if (minute.length == 1) {
							minute = '0' + minute;
						}
						for (var i = 0; i < daysOfMonth.length; i++) {
							const dayOfMonth = parseInt(daysOfMonth[i]);
							let day = Numbro(dayOfMonth).format({output: "ordinal"});
							if (i == 0) {
								days = day;
							} else {
								if (i === daysOfMonth.length - 1) {
									days += ' and ' + day;
								} else {
									days += ', ' + day;
								}
							}
						}

						if (hour < 13) {
							frequencyDetails = (
								<span>
									Monthly on the {days} of the month at {this.state.cron.hour}:{minute}am{' '}
								</span>
							);
						} else {
							frequencyDetails = (
								<span>
									Monthly on the {days} of the month at {(hour - 12).toString()}:{minute}pm{' '}
								</span>
							);
						}
					} else {
						frequencyDetails = (
							<div>
								<div className="form-group frequency-details monthly">
									<div>
										<FormGroup>
								            <FormLabel>Which days of the month?</FormLabel>
											<Grid container>
												{dayOfMonthOpts.map((o) => {
													return (
														<Grid item key={o.label} xs={6} sm={3} md={2} lg={1}>
															<FormControlLabel
																control={
																	<Switch
																		color="secondary"
																		checked={this.includes(
																			dayOfMonth,
																			o.value.toString()
																		)}
																		onChange={this.updateDayOfMonth(o.value)}
																	/>
																}
																label={Numbro(o.value).format({output: "ordinal"})}
															/>
														</Grid>
													);
												})}
											</Grid>
										</FormGroup>
									</div>
								</div>
								<FormControl className={classes.formControl}>
									<InputLabel htmlFor="time-opts">At what time during the day?</InputLabel>
									<Select
										value={monthlyTimeValue || ''}
										onChange={this.updateTime}
										input={<Input name="time-opts" id="time-opts" />}
										autoWidth
									>
										{timeOpts.map((o) => {
											return (
												<MenuItem key={o.label} value={o.value}>
													{o.label}
												</MenuItem>
											);
										})}
									</Select>
									<FormHelperText>The time the email will be delivered.</FormHelperText>
								</FormControl>
							</div>
						);
					}
					break;
				default:
			}
		}

		if (this.props.readOnly) {
			return <div className="cron readonly">{frequencyDetails}</div>;
		} else {
			return (
				<div>
						<FormControl required className={classes.frequency}>
							<InputLabel htmlFor="frequency-opts">Select a frequency</InputLabel>
							<Select
								value={frequency || ''}
								onChange={this.updateFrequency}
								input={<Input name="frequency-opts" id="frequency-opts" />}
								autoWidth
							>
								{frequencyOpts.map((o) => {
									return (
										<MenuItem key={o.label} value={o.value}>
											{o.label}
										</MenuItem>
									);
								})}
							</Select>
							<FormHelperText>
								This is the frequency with which your subscription will be delivered.
							</FormHelperText>
						</FormControl>
						{frequencyDetails}
				</div>
			);
		}
	}
}

export default withStyles(styles)(CronSelectView);
